/**
 * PostHog Event Registry (frontend mirror).
 *
 * Keep in sync with server/config/posthogEvents.js.
 * Every posthog.capture() call should use a constant from this module.
 */

// -- Auth --
export const USER_SIGNED_UP = "user_signed_up";
export const USER_LOGGED_IN = "user_logged_in";
export const LOGIN_FAILED = "login_failed";
export const PASSWORD_RESET_REQUESTED = "password_reset_requested";
export const PASSWORD_SET = "password_set";

// -- Account --
export const USER_PROFILE_UPDATED = "user_profile_updated";
export const NOTIFICATION_PREFERENCES_UPDATED =
  "notification_preferences_updated";
export const ADDRESS_CREATED = "address_created";

// -- Browsing --
export const PRODUCT_VIEWED = "product_viewed";
export const SHOP_VIEWED = "shop_viewed";
export const SEARCH = "search";
export const VARIANT_SELECTED = "variant_selected";
export const RECOMMENDATION_CLICKED = "recommendation_clicked";
export const RELATED_SHOP_CLICKED = "related_shop_clicked";

// -- Cart --
export const CART_ITEM_ADDED = "cart_item_added";
export const CART_ITEM_REMOVED = "cart_item_removed";
export const CART_ADD_FAILED = "cart_add_failed";
export const ADDON_TOGGLED = "addon_toggled";

// -- Checkout --
export const CHECKOUT_STARTED = "checkout_started";
export const CHECKOUT_STEP_VIEWED = "checkout_step_viewed";
export const CHECKOUT_COMPLETED = "checkout_completed";
export const CHECKOUT_FAILED = "checkout_failed";
export const PRODUCT_PURCHASED = "product_purchased";
export const PAYMENT_METHOD_SELECTED = "payment_method_selected";

// -- Subscriptions --
export const SUBSCRIPTION_CREATED = "subscription_created";
export const SUBSCRIPTION_CANCELLED = "subscription_cancelled";
export const SUBSCRIPTION_TRIAL_STARTED = "subscription_trial_started";
export const TRIAL_SUBSCRIPTION_CANCELLED = "trial_subscription_cancelled";

// -- Stripe Webhooks --
export const INVOICE_PAYMENT_SUCCEEDED = "invoice_payment_succeeded";
export const PAYMENT_FAILED = "payment_failed";
export const SETUP_INTENT_SUCCEEDED = "setup_intent_succeeded";

// -- Post-purchase --
export const ORDER_CANCELLED = "order_cancelled";
export const ORDER_REFUNDED = "order_refunded";
export const ORDER_SHIPPED = "order_shipped";

// -- Engagement --
export const PRODUCT_FAVOURITED = "product_favourited";
export const PRODUCT_UNFAVOURITED = "product_unfavourited";
export const SHOP_FAVOURITED = "shop_favourited";
export const SHOP_UNFAVOURITED = "shop_unfavourited";
export const NEWSLETTER_SUBSCRIBED = "newsletter_subscribed";
export const WAITLIST_JOINED = "waitlist_joined";
export const WAITLIST_NOTIFIED = "waitlist_notified";
export const WIN_BACK_PROCESS_STARTED = "win_back_process_started";

// -- Promo --
export const PROMO_CODE_APPLIED = "promo_code_applied";
export const PROMO_CODE_REJECTED = "promo_code_rejected";

// -- Support --
export const SUPPORT_TICKET_CREATED = "support_ticket_created";

// -- Talent --
export const TALENT_ONBOARDING_SUBMITTED = "talent_onboarding_submitted";
export const TALENT_APP_PURCHASE_COMPLETED = "talent_app_purchase_completed";

// -- Cameo --
export const CAMEO_PRODUCT_SELECTED = "cameo_product_selected";
export const CAMEO_ADDON_TOGGLED = "cameo_addon_toggled";
export const CAMEO_CHECKOUT_STARTED = "cameo_checkout_started";
export const CAMEO_CART_ITEM_ADDED = "cameo_cart_item_added";
export const CAMEO_CART_ADD_FAILED = "cameo_cart_add_failed";

// -- Reliability --
export const JSS_SHEET_DETACHED = "jss_sheet_detached";

// -- Internal / Admin UI --
export const SIGNING_VIEW_SWITCHED = "signing_view_switched";

export const EVENTS = {
  ADDON_TOGGLED,
  ADDRESS_CREATED,
  CAMEO_ADDON_TOGGLED,
  CAMEO_CART_ADD_FAILED,
  CAMEO_CART_ITEM_ADDED,
  CAMEO_CHECKOUT_STARTED,
  CAMEO_PRODUCT_SELECTED,
  CART_ADD_FAILED,
  CART_ITEM_ADDED,
  CART_ITEM_REMOVED,
  CHECKOUT_COMPLETED,
  CHECKOUT_FAILED,
  CHECKOUT_STARTED,
  CHECKOUT_STEP_VIEWED,
  INVOICE_PAYMENT_SUCCEEDED,
  JSS_SHEET_DETACHED,
  LOGIN_FAILED,
  NEWSLETTER_SUBSCRIBED,
  NOTIFICATION_PREFERENCES_UPDATED,
  ORDER_CANCELLED,
  ORDER_REFUNDED,
  ORDER_SHIPPED,
  PASSWORD_RESET_REQUESTED,
  PASSWORD_SET,
  PAYMENT_FAILED,
  PAYMENT_METHOD_SELECTED,
  PRODUCT_FAVOURITED,
  PRODUCT_PURCHASED,
  PRODUCT_UNFAVOURITED,
  PRODUCT_VIEWED,
  PROMO_CODE_APPLIED,
  PROMO_CODE_REJECTED,
  RECOMMENDATION_CLICKED,
  RELATED_SHOP_CLICKED,
  SEARCH,
  SETUP_INTENT_SUCCEEDED,
  SHOP_FAVOURITED,
  SHOP_UNFAVOURITED,
  SHOP_VIEWED,
  SIGNING_VIEW_SWITCHED,
  SUBSCRIPTION_CANCELLED,
  SUBSCRIPTION_CREATED,
  SUBSCRIPTION_TRIAL_STARTED,
  SUPPORT_TICKET_CREATED,
  TALENT_APP_PURCHASE_COMPLETED,
  TALENT_ONBOARDING_SUBMITTED,
  TRIAL_SUBSCRIPTION_CANCELLED,
  USER_LOGGED_IN,
  USER_PROFILE_UPDATED,
  USER_SIGNED_UP,
  VARIANT_SELECTED,
  WAITLIST_JOINED,
  WAITLIST_NOTIFIED,
  WIN_BACK_PROCESS_STARTED,
};

/** Set of all valid event name strings for runtime validation. */
export const VALID_EVENTS = new Set(Object.values(EVENTS));
